/**
 * Точка входа фронтенд-бандла.
 *
 * Собирается Laravel Mix в public/js/app.js.
 * Подключается в layouts/app.blade.php и layouts/manager/app.blade.php.
 *
 * Что здесь:
 *   - Alpine.js 3 (ядро и старт)
 *   - store `toasts` с window.showToast API (из toast.js)
 *   - apiRequest wrapper (из api.js) — доступен как window.apiRequest и named-import
 *
 * Что НЕ здесь:
 *   - Alpine-компоненты конкретных фич (spec/file-manager/wizard) — они регистрируются в
 *     resources/js/features/* и импортируются в соответствующих коммитах (Этап 3 миграции).
 *   - Модалки подтверждения/input/select — features/dialogs (Alpine + native <dialog>),
 *     заменили legacy public/js/modal-helper.js (удалён в Sprint 11 / Волна M.3).
 */

import Alpine from 'alpinejs';
// Bootstrap 5 JS bundle (с Popper) — инициализирует data-bs-* атрибуты в menager и user layouts.
// Заменяет old_js/bootstrap.min.js (BS4 + jQuery API), который был под BS5 CSS bundle и ничего не делал.
import * as bootstrap from 'bootstrap';
import { apiRequest, APIError, CSRFTokenMismatchError, RateLimitError, NetworkError } from './api.js';
import { initDialogEnhancements, openDialog, closeDialog, focusFirstInput } from './dialog-utils.js';
import './toast.js';

// Features — инициализируются сами (guard по маркеру страницы внутри каждого модуля).
import './features/spec/index.js';
import './features/manager-request/index.js';
import './features/auth/index.js';
import './features/product-modal/index.js';
import './features/file-manager/index.js';
import './features/order/index.js';
import './features/product-catalog/index.js';
import './features/notifications/index.js';
import './features/vendor-init/index.js';
import './features/cookie/index.js';
import './features/spec-dnd/index.js';
import './features/collage-editor/index.js';
import './features/manager-user-info/index.js';
import './features/project-room-editor/index.js';
import './features/user-projects/index.js';
import './features/manager-users-list/index.js';
import './features/project-comments/index.js';
import './features/manager-projects-comments/index.js';
import './features/project-detail/index.js';
import './features/manager-projects-requests/index.js';
import './features/manager-user-project/index.js';
import './features/room-collages/index.js';
import './features/product-add-project/index.js';
import './features/project-spec/index.js';
import './features/manager-orders/index.js';
import './features/manager-user-projects/index.js';
import './features/manager-notifications-demo/index.js';
import './features/dialogs/index.js';
import './features/table/column-sync.js';
import './features/spec-chat/manager-init.js';
import './core/main.js';
import './core/script.js';

// Глобальный доступ для страниц, которые пока не бандлятся через Mix (inline <script> в Blade).
window.apiRequest = apiRequest;
window.APIError = APIError;
window.CSRFTokenMismatchError = CSRFTokenMismatchError;
window.RateLimitError = RateLimitError;
window.NetworkError = NetworkError;

window.Alpine = Alpine;
window.bootstrap = bootstrap;
Alpine.start();

// Глобальные обработчики для всех <dialog>: backdrop-click и Esc с анимацией закрытия
initDialogEnhancements();
window.openDialog = openDialog;
window.closeDialog = closeDialog;
window.focusFirstInput = focusFirstInput;
